import { twMerge } from "tailwind-merge";

const AlertBox = ({
  children,
  title,
  className,
  titleClassName,
}: {
  children: React.ReactNode;
  title?: React.ReactNode;
  className?: string;
  titleClassName?: string;
}) => {
  return (
    <div
      className={twMerge(
        "bg-[#f7dd59] w-full p-[15px] text-bearish-rad text-[15px] text-active-black leading-[1.39]",
        className
      )}
    >
      {title && (
        <div
          className={twMerge(
            "text-[22px] font-light mb-[15px]",
            titleClassName
          )}
        >
          {title}
        </div>
      )}
      {children}
    </div>
  );
};

export default AlertBox;
